export default "__VITE_ASSET__BlT4IeZW__"